import { DIALOG_TYPE } from '../../define/global';
import { useDialogSliceSelector } from '../../store/modules/dialog';
import DocumentDownloadDialog from './DocumentDownloadDialog';
import OpenDocumentDialog from './OpenDocumentDialog';
import MoreFeaturesDialog from './MoreFeaturesDialog';
import ShareDocumentLinkDialog from './ShareDocumentLinkDialog';
import InvalidShareLinkDialog from './InvalidShareLinkDialog';
import { useEffect, useState } from 'react';
import AddFavoriteDialog from './AddFavoriteDialog';
import RenameDialog from './RenameDialog';
import DropboxErrorDialog from './DropboxErrorDialog';
import WhaleSpaceLoginDialog from './WhaleSpaceLoginDialog';
import ExportPDFDialog from './ExportPDFDialog';
import UserInfoDialog from './UserInfoDialog';
import UploadItt from './UploadItt';
import ActiveLinkVoteDialog from './activeLink/ActiveLinkVoteDialog';
import ActiveLinkShareOpinionDialog from './activeLink/ActiveLinkShareOpinionDialog';
import ActiveLinkInsertITTContents from './activeLink/ActiveLinkInsertITTContents';
import ActiveLinkImageGrid from './activeLink/ActiveLinkImageGrid';
import ActiveLinkSeating from './activeLink/ActiveLinkSeating';
import TranslateDialog from './TranslateDialog';
import NaverWorksDriveDialog from './NaverWorksDriveDialog';
import ActiveLinkYoutube from './activeLink/ActiveLinkYoutube';
import ActiveLinkMap from './activeLink/ActiveLinkMap';
import ActiveLinkCanvas from './activeLink/ActiveLinkCanvas';
import NaverWorksUploadFileDialog from './NaverWorksUploadFileDialog';
import ActiveLinkAnything from './activeLink/ActiveLinkAnything';

const ANI_DURATION = 300;

function DialogSelector({ isAnimation }) {
  const dialogState = useDialogSliceSelector();
  // const current = useRef(dialogState.dialogType);

  const [animate, setAnimate] = useState(false);
  const [localVisible, setLocalVisible] = useState(dialogState.isOpen);
  const [localDialogState, setLocalDialogState] = useState({
    dialogType: dialogState.dialogType,
    arg: dialogState.arg
  });

  useEffect(() => {
    if (isAnimation) {
      if (localVisible && !dialogState.isOpen) {
        setAnimate(true);
        setTimeout(() => setAnimate(false), ANI_DURATION);
      }
    }

    setLocalVisible(dialogState.isOpen);
    if (dialogState.dialogType !== DIALOG_TYPE.DIALOG_NONE)
      setLocalDialogState({ dialogType: dialogState.dialogType, arg: dialogState.arg });
  }, [localVisible, dialogState, isAnimation]);

  if (!animate && !localVisible) return null;

  return (
    <>
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_OPEN_DOCUMENT && (
        <OpenDocumentDialog isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_DOWNLOAD_DOCUMENT && (
        <DocumentDownloadDialog from={localDialogState.arg.from} isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_INSTALL_DOCUMENT && (
        <MoreFeaturesDialog from={localDialogState.arg.from} isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_SHARE_LINK_DOCUMENT && (
        <ShareDocumentLinkDialog isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_INVALID_SHARE_LINK && (
        <InvalidShareLinkDialog isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_ADD_FAVORITE && (
        <AddFavoriteDialog isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_FILE_RENAME && (
        <RenameDialog isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_DROPBOX_ERROR && (
        <DropboxErrorDialog error={localDialogState.arg.error} isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_WHALESPACE_LOGIN && (
        <WhaleSpaceLoginDialog
          isShow={dialogState.isOpen}
          userName={localDialogState.arg.userName}
        />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_EXPORT_PDF && (
        <ExportPDFDialog isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_WHALESPACE_USERINFO && (
        <UserInfoDialog isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_UPLOAD_ITT && (
        <UploadItt isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_ACTIVELINK_VOTE && (
        <ActiveLinkVoteDialog isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_ACTIVELINK_SHAREOPINION && (
        <ActiveLinkShareOpinionDialog isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_ACTIVELINK_INSERT_ITT_CONTENTS && (
        <ActiveLinkInsertITTContents isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_ACTIVELINK_INSERT_IMAGE_GRID && (
        <ActiveLinkImageGrid isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_ACTIVELINK_SEATING && (
        <ActiveLinkSeating isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_ACTIVELINK_YOUTUBE && (
        <ActiveLinkYoutube isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_ACTIVELINK_MAP && (
        <ActiveLinkMap isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_ACTIVELINK_ANYTHING && (
        <ActiveLinkAnything isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_ACTIVELINK_CANVAS && (
        <ActiveLinkCanvas isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_TRANSLATE && (
        <TranslateDialog isShow={dialogState.isOpen} />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_NAVERWORKS_BROWSER && (
        <NaverWorksDriveDialog
          isShow={dialogState.isOpen}
          from={localDialogState.arg.from}
          navigatorType={localDialogState.arg.navigatorType}
        />
      )}
      {localDialogState.dialogType === DIALOG_TYPE.DIALOG_UPLOAD_NAVERWORKS_FILE && (
        <NaverWorksUploadFileDialog
          isShow={dialogState.isOpen}
          driveType={localDialogState.arg.driveType}
          driveId={localDialogState.arg.driveId}
          fileId={localDialogState.arg.fileId}
          folderId={localDialogState.arg.folderId}
        />
      )}
    </>
  );
}

export default DialogSelector;
